module.exports = __webpack_public_path__ + "static/1-064c7a54abf9ebb4586d5ac59364f1aa.jpg";